export const RECEIVABLE_ACCOUNT_SYSTEM_ROLE = 'accountsReceivable'
